// ReactJs
import React from 'react'
// Node modules
import styled from 'styled-components'
// Styles
import theme from '../../../common/theme'
import Button from '../../../common/Button'

const WelcomePageFileDepositContainer = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  .notice {
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.111111px;
    color: ${ theme.palette.dark_blue };
    margin-top: 5px;
  }

`

export default function WelcomePageFileDeposit({ ...props }) {
  return (
    <WelcomePageFileDepositContainer>
      <Button to="deposit">
        Je dépose un dossier
      </Button>
      <span className="notice">
        Un dossier est à constituer pour chaque enfant et pour chaque mode de garde différent (Crèche, Assistance maternelle, etc.)
      </span>
    </WelcomePageFileDepositContainer>
  )
}
